import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ConservazioneCaricaDocumentoRegistroBeniDiTerziStep2Component } from './conservazione-carica-documento-registro-beni-di-terzi-step2';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.conservazione-carica-documento-registro-beni-di-terzi-step2', {
            url: '/conservazione-carica-registro-beni-di-terzi',
            ncyBreadcrumb: {
                label: 'Carica Registro Beni di Terzi',
                parent: 'home.conservazione'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Conservazione Carica Documento'
            },
            'views': {
                'homeContent': {
                    template: '<conservazione-carica-documento-registro-beni-di-terzi-step2 flex="100"></conservazione-carica-documento-registro-beni-di-terzi-step2>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoRegistroBeniDiTerziStep2Module: string = ng
    .module('conservazione-carica-documento-registro-beni-di-terzi-step2', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('conservazioneCaricaDocumentoRegistroBeniDiTerziStep2', ConservazioneCaricaDocumentoRegistroBeniDiTerziStep2Component)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-registro-beni-di-terzi-step2/conservazione-carica-documento-registro-beni-di-terzi-step2.module.ts